import {
  Box,
  FormControlLabel,
  Link,
  Radio,
  RadioGroup,
  Typography
} from '@mui/material';
import { CampaignCreationSection } from 'pages/CampaignCreation/components/CampaignCreationSection';

const LANGUAGE_LABELS: Record<string, string> = {
  en_us: 'English (US)',
  en_gb: 'English (UK)',
  en_ca: 'English (Canada)',
  de: 'German',
  nl: 'Dutch',
  nl_be: 'Flemish',
  fr: 'French',
  es: 'Spanish',
  it: 'Italian',
  pt_br: 'Portuguese (Brazil)'
};

const REQUEST_LANGUAGES_URL =
  'https://portal.usepylon.com/popp/forms/requestlanguage';

type CampaignLanguageSelectorProps = {
  availableLanguages: string[];
  selectedLanguage: string;
  onChange: (language: string) => void;
};

export const CampaignLanguageSelector: React.FC<
  CampaignLanguageSelectorProps
> = ({ availableLanguages, selectedLanguage, onChange }) => {
  const options = availableLanguages.map((value) => ({
    value,
    label: LANGUAGE_LABELS[value] ?? value
  }));

  return (
    <CampaignCreationSection
      title="Campaign language"
      subTitle="Set a language for this campaign."
    >
      <Box>
        <RadioGroup
          value={selectedLanguage}
          onChange={(e) => onChange(e.target.value)}
          sx={{ gap: '15px' }}
        >
          {options.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio />}
              label={option.label}
              sx={{
                color: 'customGrey.dark',
                marginLeft: 0
              }}
            />
          ))}
        </RadioGroup>
        <Typography variant="body2" sx={{ mt: 1 }}>
          <Link
            href={REQUEST_LANGUAGES_URL}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
          >
            Request additional languages
          </Link>
        </Typography>
      </Box>
    </CampaignCreationSection>
  );
};
